import { render, staticRenderFns } from "./ClinicConfirmations.vue?vue&type=template&id=310091a4"
import script from "./ClinicConfirmations.vue?vue&type=script&lang=js"
export * from "./ClinicConfirmations.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports